const messages = {
    title: "Radovi na održavanju",
    description: "Neophodni radovi na održavanju se trenutno izvode na serverima." +
        "<br/><br/>Kao rezultat, pristup <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b> " +
        "vam trenutno nije dostupan.<br/><br/>Zahvaljujemo se na strpljenju i razumevanju." +
        "<br/><br/> Vaš Bridgestone tim"
}
export default {
    messages
}
